import React from 'react';
import {Flex, Text} from "@chakra-ui/react";

interface EmptyProjectTableViewProps {
  onCreateNewProjectClicked: () => void
}


const EmptyProjectTableView: React.FC<EmptyProjectTableViewProps> = (
  {
    onCreateNewProjectClicked
  }: EmptyProjectTableViewProps) => {
  return (
    <Flex className="w-full h-full flex-1 flex-col justify-center items-center gap-6">
      <Text fontSize="xl">Lets make your first project!</Text>
      <Flex
        className="w-[200px] h-20 bg-brandPurple-500 p-2 rounded-lg font-semibold justify-center cursor-pointer hover:bg-violetPurple-500 items-center"
        onClick={onCreateNewProjectClicked}>
        Create New Project
      </Flex>
    </Flex>
  )
}

export default EmptyProjectTableView;